class CountdownTimer extends HTMLElement {
  connectedCallback() {
    const end = this.dataset.end;
    this.endTime = end ? new Date(end).getTime() : NaN;
    this.onExpire = this.dataset.expire || 'message';

    // Mod evergreen: când expiră, o ia de la capăt (loop)
    this.loop = this.onExpire === 'restart';
    if (this.loop) {
      // durata unui ciclu = timpul rămas la încărcare; dacă data a trecut, folosește 24h
      this.duration = this.endTime - Date.now();
      if (!(this.duration > 0)) {
        this.duration = 24 * 60 * 60 * 1000;
        this.endTime = Date.now() + this.duration;
      }
    }

    this.fields = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };
    this.timerEl = this.querySelector('[data-countdown]');
    this.expiredEl = this.querySelector('[data-expired]');

    if (isNaN(this.endTime)) return;

    this.update();
    this.interval = setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  update() {
    const diff = this.endTime - Date.now();

    if (diff <= 0) {
      if (this.loop) {
        // resetează la durata inițială și continuă (o ia de la început)
        this.endTime = Date.now() + this.duration;
        return;
      }
      clearInterval(this.interval);
      this.expire();
      return;
    }

    const s = Math.floor(diff / 1000);
    this.set('days', Math.floor(s / 86400));
    this.set('hours', Math.floor((s % 86400) / 3600));
    this.set('minutes', Math.floor((s % 3600) / 60));
    this.set('seconds', s % 60);
  }

  set(unit, value) {
    if (this.fields[unit]) {
      this.fields[unit].textContent = String(value).padStart(2, '0');
    }
  }

  expire() {
    Object.values(this.fields).forEach((el) => {
      if (el) el.textContent = '00';
    });

    if (this.onExpire === 'hide') {
      const section = this.closest('.shopify-section') || this;
      section.setAttribute('hidden', '');
    } else if (this.onExpire === 'message' && this.expiredEl) {
      if (this.timerEl) this.timerEl.setAttribute('hidden', '');
      this.expiredEl.removeAttribute('hidden');
    }
  }
}

if (!customElements.get('countdown-timer')) {
  customElements.define('countdown-timer', CountdownTimer);
}
